// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-imports
const DOMPurify = globalThis.DOMPurify;
if (!DOMPurify) {
    // eslint-disable-next-line no-console
    console.error('DOMPurify global not found. In production, load DOMPurify via <script> before your app.');
}
export default DOMPurify;
